
import { Injectable } from '@angular/core';
import { HttpService } from '../providers/http.service';
import { AppConfig } from '../app/app.config';

@Injectable()
export class KaiYuanService {
    constructor(private httpService: HttpService) { }

    /**
     * 登录开元棋牌
     * TQQ 2018-12-07
     */
    login(kindId: string = '0') {
        let url = AppConfig.GetProdUrl() + "/KaiYuan/Login";
        return this.httpService.post(url, { KindID: kindId });
    }

    /**
     * 转账
     * type='2':转账到开元
     * TQQ 2018-12-10
     */
    transferToKaiYuan(money: number) {
        let url = AppConfig.GetProdUrl() + "/KaiYuan/TransferToKaiYuan";
        return this.httpService.post(url, { Money: money, Type: '2' });
    }

    /**
     * 转账
     * type='3':从开元转出
     * TQQ 2018-12-10
     */
    transferFromKaiYuan(money: number) {
        let url = AppConfig.GetProdUrl() + "/KaiYuan/TransferFromKaiYuan";
        return this.httpService.post(url, { Money: money, Type: '3' });
    }

    /**
     * 获取余额
     * TQQ 2018-12-10
     */
    getKaiYuanBalance() {
        let url = AppConfig.GetProdUrl() + "/KaiYuan/GetBalance";
        return this.httpService.post(url, null);
    }

    /**
     * 转账记录
     * TQQ 2018-12-12
     */
    getTransferList(params) {
        let url = AppConfig.GetProdUrl() + "/KaiYuan/GetTransferList";
        return this.httpService.post(url, params);
    }

    /**
     * 投注记录
     * TQQ 2018-12-12
     */
    getBettingList(params) {
        let url = AppConfig.GetProdUrl() + "/KaiYuan/GetBettingList";
        return this.httpService.post(url, params);
    }


    /**
     * 判断开元棋牌是否开启
     * evan 2018-12-28
     * @returns
     * @memberof IndexService
     */
    getKaiYuanIsOpen() {
        let url = AppConfig.GetProdUrl() + '/KaiYuan/KaiYuanisOpen';
        return this.httpService.post(url, null)
    }

    /**
     * 团队报表
     */
    getTeamRepotrList(params) {
        let url = AppConfig.GetProdUrl() + '/KaiYuan/GetKaiYuanTeamReportList';
        return this.httpService.post(url, params);
    }
    /**
     *
     * 个人报表
     */
    getUserReportList(params) {
        let url = AppConfig.GetProdUrl() + '/KaiYuan/GetUserReportList';
        return this.httpService.post(url, params);
    }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/services/kaiyuan.service.ts